<div appDialogSelectable appDialogKeyboardEnabled>
  <div
    class="atlas-first-contact-template-dialog"
    (cdkDragStarted)="dialogBoundryService.handleDragStart($event)"
    (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)"
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDrag
  >
    <div appDialogDragArea cdkDragHandle></div>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">First Contact Template: {{ context?.caseNumber || '-' }}</div>
        <div class="modal-buttons">
          <div (click)="close()">
            <img src="/assets/icons/Close White.svg" alt="Close" />
          </div>
        </div>
      </div>

      <div class="modal-content-body first-contact-template-dialog">
        <div class="modal-body">
          <div class="template-shell">
            <div class="template-shell-header">
              <div class="template-shell-title-group">
                <div class="dialog-title template-title">Template Questions</div>
                <div class="template-context-hint">Fill out uses the enabled fields from Case context and answers the questions with AI</div>
              </div>
              <div class="template-shell-actions">
                <div class="question-count">{{ questionRows.length }} questions</div>
                <button
                  class="reload-button"
                  type="button"
                  aria-label="Reload template questions"
                  [disabled]="loading || fillOutLoading"
                  (click)="reloadTemplateContext()"
                >
                  Reload
                </button>
                <button
                  class="fill-out-button"
                  type="button"
                  aria-label="Fill out with AI"
                  [disabled]="loading || fillOutLoading || questionRows.length === 0"
                  (click)="fillOutTemplate()"
                >
                  {{ fillOutLoading ? 'Filling out with AI...' : 'Fill out with AI' }}
                </button>
                <button
                  class="copy-button"
                  [class.copy-button-success]="copied"
                  type="button"
                  [disabled]="loading || questionRows.length === 0"
                  (click)="copyQuestionsAndAnswers()"
                >
                  {{ copied ? 'Copied!' : 'Copy' }}
                </button>
                <button
                  class="paste-note-button"
                  [class.paste-note-button-success]="pastedToPhoneNote"
                  type="button"
                  [disabled]="loading || questionRows.length === 0"
                  (click)="pasteToPhoneNoteField()"
                >
                  {{ pastedToPhoneNote ? 'Pasted!' : 'Paste to phone note' }}
                </button>
              </div>
            </div>

            <div *ngIf="loading" class="dialog-status loading">
              <span class="loading-dot"></span>
              {{ loadingMessage }}
            </div>

            <div *ngIf="!loading && requestError" class="dialog-status error">
              {{ requestError }}
            </div>

            <div *ngIf="!loading && !requestError && questionRows.length > 0" class="question-table-wrapper">
              <table class="question-table">
                <thead>
                  <tr>
                    <th>Question</th>
                    <th>Answer</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let row of questionRows; let idx = index">
                    <tr *ngIf="showAnsweredSectionDivider(idx)" class="question-section-break-row">
                      <td colspan="2">
                        <div class="question-section-break">
                          <span class="question-section-break-line"></span>
                          <span class="question-section-break-label">Answered questions</span>
                          <span class="question-section-break-line"></span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="question-text">{{ row.questionText }}</div>
                        <div *ngIf="row.templateName" class="question-template-badge">
                          <span class="question-template-badge-label">Template:</span>
                          <span>{{ row.templateName }}</span>
                        </div>
                      </td>
                      <td>
                        <textarea
                          class="answer-input"
                          [(ngModel)]="row.answerText"
                          (ngModelChange)="onAnswerChanged(row)"
                          (blur)="onAnswerBlur(row)"
                          placeholder="Answer..."
                        ></textarea>
                        <div *ngIf="getAnswerSourceLabel(row)" class="answer-source-badge">
                          {{ getAnswerSourceLabel(row) }}
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>

            <div *ngIf="!loading && !requestError && questionRows.length === 0" class="dialog-status empty">
              No questions returned.
            </div>

            <div *ngIf="!loading && !requestError && fillOutError" class="dialog-status error">
              {{ fillOutError }}
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
